import React from 'react';

const NotificationModal = () => {
  return <div></div>;
};

export default NotificationModal;
